module.exports = __webpack_public_path__ + "static/media/menu_user_add.c483e95a.png";